import classNames from "classnames";
import React from "react";
import { t } from "ttag";

import { isoImageURL } from "../models/nominals";
import { IValueProp } from "../models/value-props";
import { UncontrolledPopover } from "./Popover";
import { RichText } from "./RichText";

import styles from "./ValueProp.module.scss";

interface IProps {
    prop: IValueProp;
    className?: string;
}

const ValueProp = (props: IProps): React.ReactNode => {
    const content = (
        <>
            {props.prop.icon && (
                <img
                    loading="lazy"
                    src={isoImageURL.unwrap(props.prop.icon.url)}
                    alt=""
                />
            )}
            <div
                className="value-prop-list-item__copy"
                dangerouslySetInnerHTML={{
                    __html: props.prop.title + props.prop.subtitle,
                }}
            />
        </>
    );

    const listItemClasses = classNames(styles.listItem, props.className || "");

    if (!props.prop.show_tooltip) {
        return (
            <li className={listItemClasses}>
                <span>{content}</span>
            </li>
        );
    }

    const modalClasses = classNames(styles.modal, "place-bottom");

    return (
        <li className={listItemClasses}>
            <UncontrolledPopover
                triggerContent={content}
                triggerBtnProps={{}}
                popperOptions={{
                    modifiers: [
                        {
                            name: "offset",
                            options: { offset: [0, 16] },
                        },
                        {
                            name: "flip",
                            options: {
                                fallbackPlacements: ["top", "bottom"],
                            },
                        },
                    ],
                    placement: "bottom",
                }}
                modalProps={{
                    className: modalClasses,
                    contentLabel: t`Offers`,
                    bodyOpenClassName: "ReactModal__Body--open vp-popover-open",
                    style: {
                        overlay: {
                            backgroundColor: "transparent",
                        },
                    },
                }}
            >
                <RichText html={props.prop.tooltip_contents} />
            </UncontrolledPopover>
        </li>
    );
};

export default ValueProp;
